import React, { useEffect, useState } from "react";
import { Users, Loader2 } from "lucide-react";
import { adminApi } from "../../lib/api";
import { programs } from "../../mock/mock";

export const PROGRAM_OPTIONS = [{ value: "Todos", label: "Todos los programas" }, ...programs.map((p) => ({ value: p.name, label: p.name }))];
export const GRUPO_OPTIONS = [{ value: "Todos", label: "Todos los grupos" }, ...Array.from({ length: 26 }, (_, i) => { const L = String.fromCharCode(65 + i); return { value: L, label: `Grupo ${L}` }; })];

export const toggleExclusive = (cur, val) => {
  if (val === "Todos") return cur.includes("Todos") ? [] : ["Todos"];
  const base = cur.filter((x) => x !== "Todos");
  return base.includes(val) ? base.filter((x) => x !== val) : [...base, val];
};

const Grid = ({ title, options, value, onChange, cols, testid }) => (
  <div>
    <div className="text-xs font-bold text-[#0A1C30] mb-1.5">{title}</div>
    <div data-testid={testid} className={`rounded-xl ring-1 ring-black/10 p-2.5 grid ${cols} gap-1.5 bg-white`}>
      {options.map((o) => (
        <label key={o.value} data-testid={`${testid}-${o.value.replace(/\s+/g, "-")}`}
          className={`flex items-center gap-2 text-sm px-2 py-1.5 rounded-lg cursor-pointer transition-colors ${o.value === "Todos" ? "col-span-full" : ""} ${value.includes(o.value) ? "bg-[#FBF7E8]" : "hover:bg-[#FAFAFA]"}`}>
          <input type="checkbox" checked={value.includes(o.value)} onChange={() => onChange(toggleExclusive(value, o.value))} className="accent-[#E9A400] w-4 h-4" />
          <span className="text-[#2A3446] font-semibold">{o.label}</span>
        </label>
      ))}
    </div>
  </div>
);

export const AudienceCount = ({ programas, grupos, testid = "audience-count" }) => {
  const [c, setC] = useState(null);
  const key = JSON.stringify([programas, grupos]);
  useEffect(() => {
    setC(null);
    if (!programas.length || !grupos.length) return;
    const t = setTimeout(() => adminApi.audiencia({ target: "segmento", programas, grupos }).then(setC).catch(() => {}), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return (
    <div data-testid={testid} className="rounded-xl bg-[#0A1C30] text-white px-4 py-3 text-sm flex flex-wrap items-center gap-x-3 gap-y-1">
      <Users className="w-4 h-4 text-[var(--gold)]" />
      {!programas.length || !grupos.length ? <span>Elige al menos un programa y un grupo.</span>
        : !c ? <span className="inline-flex items-center gap-2"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Calculando…</span>
          : <>
            <span><b className="text-[var(--gold)]" data-testid={`${testid}-total`}>{c.total}</b> persona(s) lo recibirán</span>
            {Object.entries(c.por_programa).slice(0, 6).map(([p, n]) => <span key={p} className="text-xs text-white/70">{p}: {n}</span>)}
          </>}
    </div>
  );
};

export const AudiencePicker = ({ programas, grupos, onChange, testid = "aud" }) => (
  <div className="space-y-3">
    <Grid title="Programas que lo reciben (elige uno o varios)" options={PROGRAM_OPTIONS} value={programas} cols="grid-cols-1 sm:grid-cols-3"
      onChange={(v) => onChange({ programas: v, grupos })} testid={`${testid}-programas`} />
    <Grid title="Grupos que lo reciben (elige uno o varios)" options={GRUPO_OPTIONS} value={grupos} cols="grid-cols-3 sm:grid-cols-6"
      onChange={(v) => onChange({ programas, grupos: v })} testid={`${testid}-grupos`} />
    <p className="text-[11px] text-[#9AA3B2]">Si eliges grupos específicos, solo lo reciben los alumnos que tengan ese grupo asignado en su perfil.</p>
    <AudienceCount programas={programas} grupos={grupos} testid={`${testid}-count`} />
  </div>
);
